/**
 * 订阅相关逻辑
 * create by sevencai@20180823
 * contact seven.cailidan@gmial.com
 */

import Api from '@/api/index'

/**
 * 查询我的订阅
 * 返回订阅 groupId 数组
 * @return array
 */
export default async function getSubscribes() {
  if (window.subscribes) {
    return window.subscribes
  }

  const params = {
    action: 'query_subscribe'
  }

  if (!Api || !Api.cgiObj.request) {
    return []
  }

  const res = await Api.request('subscribe', params)
  // cgi 报错 不要影响正常逻辑
  if (res.ret) {
    return []
  }

  const subscribes = res.info.subscribe_groups.map(item => item.FGroupID)
  window.subscribes = subscribes
  return subscribes
}
